import { DataProvider, SortPayload } from "react-admin";
import { PaginationType } from "shared/types";
import { EcpResourcesEnum } from "shared/enums/resourceMappings";
import { format } from "date-fns";
import { BusinessType } from "./types";
import axios from "axios";

export const fetchYearlyBids =
  (dataprovider: DataProvider, date: Date) =>
  async ({ page, size }: PaginationType) => {
    const config = {
      sort: { field: "id", order: "ASC" } as SortPayload,
      pagination: { page, perPage: size },
      meta: { urlParams: `/effective/${format(date, "yyyy-MM-dd")}` },
    };
    const { data: items, total } = await dataprovider.getList(EcpResourcesEnum.EcpReservePlanPoints, config);
    return { items, total: Number(total) };
  };

export const AxiosFetchRegularBids =
  (business_type: BusinessType, end_date__gte: string, start_date__lte: string) =>
  async ({ page, size }: PaginationType) => {
    const {
      data: { items, total },
    } = await axios.get(`${process.env.REACT_APP_ECP_API_URL}/bids/`, {
      params: {
        page,
        size,
        business_type,
        end_date__gte,
        start_date__lte,
        soft_deleted: false,
      },
    });
    return { items, total };
  };
